/* GENERATED FROM calendar.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'

export class Calendar {
  static GetProgress = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetProgressReq, {}, commonHdr.GetProgressResp>): Promise<
    APIResponse<commonHdr.GetProgressResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/calendar/onboardingProgress`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<commonHdr.GetProgressResp>>()
          .then<APIResponse<commonHdr.GetProgressResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static OnDemandRunFSM = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<OnDemandRunFSMReq, {}, OnDemandRunFSMResp>): Promise<
    APIResponse<OnDemandRunFSMResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/calendar/onDemandRunFSM`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<OnDemandRunFSMResp>>()
          .then<APIResponse<OnDemandRunFSMResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ResetFSMState = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ResetFSMStateReq, {}, ResetFSMStateResp>): Promise<
    APIResponse<ResetFSMStateResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/calendar/resetFSMState`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ResetFSMStateResp>>()
          .then<APIResponse<ResetFSMStateResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface GetProgressReq {
  req_hdr?: base.ReqHdr
}

export interface OnDemandRunFSMReq {
  req_hdr?: base.ReqHdr
}

export interface OnDemandRunFSMResp {
  resp_hdr?: base.RespHdr
  tenant_id?: string
}

export interface HandleEventsPullReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  accounts?: HandleEventsPullAccount[]
}

export interface HandleEventsPullAccount {
  account?: base.AccountInfo
  status?: HandleEventsPullAccount_ChangeStatusEnum
}

export enum HandleEventsPullAccount_ChangeStatusEnum {
  NONE = 'NONE',
  ADDED = 'ADDED',
  DELETED = 'DELETED'
}

export interface HandleEventsPullResp {
  resp_hdr?: base.RespHdr
}

export interface ReleasePollingAwaitReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface ReleasePollingAwaitResp {
  resp_hdr?: base.RespHdr
}

export interface ResetFSMStateReq {
  req_hdr?: base.ReqHdr
}

export interface ResetFSMStateResp {
  resp_hdr?: base.RespHdr
  status?: string
}

export enum CalendarErrorEnum {
  CALENDAR_ERROR_UNKNOWN = 'CALENDAR_ERROR_UNKNOWN',
  CALENDAR_ERROR_FAILED_TO_GET = 'CALENDAR_ERROR_FAILED_TO_GET',
  CALENDAR_ERROR_FSM_ALREADY_IN_PROGRESS = 'CALENDAR_ERROR_FSM_ALREADY_IN_PROGRESS',
  CALENDAR_ERROR_FAILED_TO_DELETE = 'CALENDAR_ERROR_FAILED_TO_DELETE'
}
